var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"financial-statements-hk"},[_c(_vm.currentStatement,{tag:"components",attrs:{"data":_vm.tableData,"reportKindMap":_vm.reportKindMap,"css":_vm.css,"formatAParams":_vm.formatAParams,"mainDataStyle":_vm.mainDataStyle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }